import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentsService} from "../../services/agents-service.service";
import {WalletsRequests} from "../../../wallets/services/wallets-requests.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class AgentsPaymentTransactionsViewCtrl implements IController {

  branchIds: any;

  private loadLimit: number;
  private paymentCollectionRef: any;
  private infiniteScroll: any;
  private balance: any;
  private currencySymbol: any;
  private filterConfig: {
    branchIds: string,
    siteId: string;
    query: string
  };

  constructor(private $log, private $infiniteScroll, private agentsService: AgentsService, private walletsRequests: WalletsRequests,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $walletsBalances, private $scope: IScope,
              private agentDialogService: AgentDialogService, private WalletsConstants, private splitService: SplitService) {
  }

  $onInit() {
    this.loadLimit = 30;
    this.paymentCollectionRef = this.$walletsBalances();
    this.currencySymbol = this.splitService.getCurrencySymbol();

    this.filterConfig = {
      siteId: this.splitService.getSiteId(),
      branchIds: this.branchIds || [],
      query: undefined
    };

    this.paymentCollectionRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.paymentCollectionRef, this.loadLimit, {getFullData: true});

    this._reloadBalance();

    // this.paymentCollectionRef.$onChange(this.$scope, (collections) => {
    //   this._reloadBalance();
    // })
  }

  onBranchesSelect(branchIds) {
    if (!_.isUndefined(branchIds) && !_.isEqual(branchIds, this.filterConfig.branchIds)) {
      this.filterConfig.branchIds = branchIds;

      this._reloadCollection();
      this._reloadBalance();
    }
  }

  submitQuery(queryString) {
    this.filterConfig.query = queryString;
    this._reloadCollection();
    this._reloadBalance();
  }

  onAddTransaction(transaction, transactionType, ev) {
    const agentName = transaction.agentFirstName + ' ' + transaction.agentLastName;
    this.agentDialogService.addWalletTransaction(transactionType, agentName, ev)
      .then((addedTransaction) => {
        this._addTransaction(transaction.agentId, addedTransaction);
      })
      .catch((error) => {
        this.$log.debug('Failed to add transaction', error);
      })
  }

  onChangeOperationalUnitsType() {
    this._reloadCollection();
    this._reloadBalance();
  }

  private _reloadCollection() {
    this.paymentCollectionRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Failed to $query', error);
      })
  }

  private _reloadBalance() {
    this.walletsRequests.getAgentsTotalBalance()
      .then((balance) => {
        this.balance = balance;
      })
      .catch((error) => {
        this.$log.debug('Failed to reload balance', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit:            this.loadLimit,
      query:            this.filterConfig.query,
      branchIds:        this.filterConfig.branchIds
    }
  }

  private _addTransaction(agentId: string, transaction) {
    this.agentsService.addPaymentTransaction(agentId, transaction)
      .then((addedTransaction) => {
        this._reloadCollection();
        this._reloadBalance();
      })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsPaymentTransactionsView', {
    bindings: {
      branchIds: '<?'
    },
    template: require('./agents-payment-transactions-view.html').default,
    controller: AgentsPaymentTransactionsViewCtrl
  });
